/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminUsersControllerDeleteAdminUser$Params {
  id: string;
}

export function adminUsersControllerDeleteAdminUser(http: HttpClient, rootUrl: string, params: AdminUsersControllerDeleteAdminUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'userId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerDeleteAdminUser.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'userId'?: string;
      }>;
    })
  );
}

adminUsersControllerDeleteAdminUser.PATH = '/admin/users/{id}';
